import { alerts } from 'modules/alerts/actions';
import { getInWithNullFilter } from 'utils/filter-utils';
import Rest from 'services/data/rest';
import Promise from 'bluebird';
import _ from 'lodash';
import axios from 'axios';
import * as pageData from 'modules/page-data/actions';
import * as socket from 'services/socket';


export default class Company extends Rest {
  static path = 'company';
  static defaultQuery = {
    sort: 'name',
    load: ['primaryTech', 'team']
  };

  static mapFilters(filters) {
    const { status, companyType, primaryTech, paymentStatus, ...where } = filters;

    if (status && status.length) where.status = { in: status };
    if (primaryTech && primaryTech.length) where.primaryTech = { in: primaryTech };

    where.companyType = getInWithNullFilter(companyType);
    where.balance = getBalanceFilter(paymentStatus);

    return where;
  }

  static initializeSocket() {
    Company.loadSelectCompanies();

    socket.registerSocket('company', (changedCompany) => {
      pageData.updateOne('selectCompanies', changedCompany);
    }, Company.loadSelectCompanies);
  }

  static loadSelectCompanies() {
    Company.find({ sort: 'name' })
      .then((companies) => {
        pageData.update('selectCompanies', companies, ['name']);
      })
      .catch(alerts.catchError);
  }

  static getBillingEscalators() {
    return Promise.resolve(axios.get('/api/company/billing-escalators'))
      .tap(this.logRequest)
      .get('data')
      .catch(alerts.catchError);
  }
}

function getBalanceFilter(status) {
  const paid = _.includes(status, 'Paid');
  const unpaid = _.includes(status, 'Unpaid');

  if (paid && !unpaid) return 0;
  if (!paid && unpaid) return { '>': 0 };
}



// WEBPACK FOOTER //
// ./app/services/data/company.js